import React, { useContext } from 'react';
import moment from 'moment';
import _get from 'lodash/get';
import _upperFirst from 'lodash/upperFirst';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';
import { useNotes } from 'utils/hooks';
import { ReactComponent as DeleteIcon } from 'assets/img/icons/delete-muted.svg';

export default function Note({ data = {}, onDelete = () => {} }) {
  const { userData } = useContext(AuthContext);
  const { isDeletable, deletingId, isDisabled } = useNotes();

  const id = _get(data, 'id') || '';
  const note = _get(data, 'note') || '';
  const createdAt = _get(data, 'created_at') || '';
  const createdBy = _get(data, 'created_by_user_name') || '';
  const userId = _get(data, 'created_by_user_id') || '';
  const loggedInUserId = `${_get(userData, 'userId')}` || '';

  const allowDelete = isDeletable && userId === loggedInUserId;
  const createdDateTime = moment(createdAt).format('Do MMM YYYY, h:mm a');
  const elapsedCreatedTime = moment(createdAt).fromNow();
  const username = createdBy
    .split(' ')
    .map(name => _upperFirst(name))
    .join(' ');

  const onDeleteClick = () => {
    if (!allowDelete) return;
    onDelete();
  };

  return (
    <li className={styles.note}>
      <UiKit.Grid templateColumns="1fr" gap="4">
        <p className={styles.text}>{note}</p>
        <div className={styles.meta}>
          {username},
          <UiKit.Tooltip>
            <UiKit.Tooltip.Trigger>{elapsedCreatedTime}</UiKit.Tooltip.Trigger>
            <UiKit.Tooltip.Content>{createdDateTime}</UiKit.Tooltip.Content>
          </UiKit.Tooltip>
        </div>
      </UiKit.Grid>
      <If test={allowDelete}>
        <UiKit.Button
          size="sm"
          variant="ghost"
          onClick={onDeleteClick}
          disabled={!!deletingId || isDisabled}
          processing={id === deletingId}
          className={styles.btn}
        >
          <DeleteIcon />
        </UiKit.Button>
      </If>
    </li>
  );
}
